module.exports = __webpack_public_path__ + "static/media/2checkout-dark.65d58d80.svg";